import { i18n } from '../services/i18n.js';
import { dbSim } from '../services/dbSim.js';
import { escapeHTML } from '../services/sanitize.js';
import { realtimeSim } from '../services/realtimeSim.js';
import { icon } from '../services/icons.js';
import { showReaction } from '../services/reactions.js';

export const PodiumView = async (container) => {
  // Parse query parameters
  const hashParts = window.location.hash.split('?');
  const query = hashParts[1] || '';
  const urlParams = new URLSearchParams(query);
  const sessionId = urlParams.get('session');

  container.innerHTML = `<div class="container" style="padding:40px; text-align:center; color:var(--color-text-secondary);">${i18n.t('preparing_podium')}</div>`;

  const session = await dbSim.getSession(sessionId);
  if (!session) {
    window.showToast(i18n.t('session_not_found'));
    window.location.hash = '#/dashboard';
    return;
  }
  if (session.status !== 'finished') {
    window.showToast(i18n.t('session_not_finished'));
    window.location.hash = '#/dashboard';
    return;
  }

  const game = await dbSim.getSessionGame(session.id);

  const leaderboard = await dbSim.getLeaderboard(session.id);
  const winner1st = leaderboard[0] || { nickname: "N/A", score: 0 };
  const winner2nd = leaderboard[1] || { nickname: "N/A", score: 0 };
  const winner3rd = leaderboard[2] || { nickname: "N/A", score: 0 };

  const render = () => {
    container.innerHTML = `
      <div class="host-screen" style="flex:1; display:flex; flex-direction:column; background: var(--color-bg); padding:40px; justify-content:space-between; min-height:100vh; position:relative; overflow:hidden;">
        
        <!-- Header -->
        <div class="host-header" style="display:flex; justify-content:space-between; align-items:center; z-index:10;">
          <div class="session-brand session-brand-left">
            ${game?.brand?.name ? `<strong>${escapeHTML(game.brand.name)}</strong>` : ''}
            <span>${icon('trophy')} ${i18n.t('podium_title')}</span>
          </div>
          <div class="host-actions" style="display:flex; gap:12px;">
            <button id="screenshotBtn" class="btn btn-secondary">${icon('camera')} ${i18n.t('podium_screenshot')}</button>
            <button id="shareBtn" class="btn btn-secondary">${icon('link')} ${i18n.t('podium_share')}</button>
            <a href="#/reports/${session.id}" class="btn btn-primary" style="box-shadow:var(--shadow-glow);">
              ${icon('chart')} ${i18n.t('view_report')}
            </a>
          </div>
        </div>

        <!-- Center Podium display -->
        <div style="text-align:center; z-index:10; margin:40px 0;">
          <h1 style="font-size:36px; font-weight:800; color:var(--color-accent); text-shadow: var(--shadow-glow-pink); margin-bottom:12px;">
            ${i18n.t('podium_winner')}
          </h1>
          <p style="color:var(--color-text-secondary); font-size:15px; margin-bottom:60px;">
            ${i18n.t('podium_energy')}
          </p>

          <div class="podium-container">
            <!-- 2nd Place -->
            <div class="podium-column podium-2nd">
              <div class="podium-name">${escapeHTML(winner2nd.nickname)}</div>
              <div class="podium-medal" style="color:#cbd5e1;">${icon('trophy', 'reaction-icon')}</div>
              <div style="font-weight:800; font-size:18px;">2nd</div>
              <div class="podium-score">${winner2nd.score} pts</div>
            </div>

            <!-- 1st Place -->
            <div class="podium-column podium-1st pulse-heart">
              <div class="podium-name" style="font-size:20px; color:var(--color-accent); font-weight:800; text-shadow:0 0 10px rgba(255,93,170,0.5);">${escapeHTML(winner1st.nickname)}</div>
              <div class="podium-medal" style="color:#facc15;">${icon('trophy', 'reaction-icon')}</div>
              <div style="font-weight:800; font-size:22px; color:#ffd700;">1st</div>
              <div class="podium-score" style="color:var(--color-text-primary); font-weight:700;">${winner1st.score} pts</div>
            </div>

            <!-- 3rd Place -->
            <div class="podium-column podium-3rd">
              <div class="podium-name">${escapeHTML(winner3rd.nickname)}</div>
              <div class="podium-medal" style="color:#d97706;">${icon('trophy', 'reaction-icon')}</div>
              <div style="font-weight:800; font-size:16px;">3rd</div>
              <div class="podium-score">${winner3rd.score} pts</div>
            </div>
          </div>
        </div>

        <!-- Footnote: Back to Dashboard Link -->
        <div style="text-align:center; z-index:10;">
          <a href="#/dashboard" class="podium-back-link">
            ${i18n.t('back_host_dashboard')} ${icon('arrowRight')}
          </a>
        </div>

      </div>
    `;

    // Start Confetti Fireworks
    initConfetti(container);

    // Bind Buttons Action
    container.querySelector('#screenshotBtn').addEventListener('click', () => {
      window.showToast(i18n.t('screenshot_saved'));
    });

    container.querySelector('#shareBtn').addEventListener('click', () => {
      if (navigator.share) {
        navigator.share({
          title: 'Heart150 Winner!',
          text: `Chúc mừng ${winner1st.nickname} đã vô địch cuộc thi với ${winner1st.score} điểm!`,
          url: window.location.href,
        }).catch(err => console.log(err));
      } else {
        window.showToast(i18n.t('share_copied'));
      }
    });
  };

  const initConfetti = (rootEl) => {
    const confettiContainer = document.createElement('div');
    confettiContainer.className = 'confetti-container';
    rootEl.appendChild(confettiContainer);

    const colors = ['#ff3b5c', '#ff5daa', '#10b981', '#f59e0b', '#3b82f6'];
    for (let i = 0; i < 80; i++) {
      const piece = document.createElement('div');
      piece.className = 'confetti-piece';
      piece.style.left = `${Math.random() * 100}%`;
      piece.style.top = `-${Math.random() * 20}px`;
      piece.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      piece.style.width = `${Math.random() * 8 + 6}px`;
      piece.style.height = `${Math.random() * 15 + 8}px`;
      piece.style.animationDelay = `${Math.random() * 3}s`;
      piece.style.animationDuration = `${Math.random() * 2 + 2}s`;
      confettiContainer.appendChild(piece);
    }
  };

  render();

  realtimeSim.connect(session.pin, (type, payload) => {
    if (type === 'SEND_REACTION') showReaction(container, payload.reaction);
  });

  window.addEventListener('hashchange', function cleanup() {
    realtimeSim.disconnect();
    window.removeEventListener('hashchange', cleanup);
  });
};
